import { render } from "./Logo.vue?vue&type=template&id=2c76c486&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=2c76c486&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c76c486"

export default script